export default __webpack_public_path__ + "images/03c1cf69baea8becf6be1a30c5d1f8aa.png";